/**
 * 创建空的外部链接卡片 payload
 */
export const createEmptyExternalPayload = () => {
  return {
    card_type: 'external',
    type: 'external',
    title: '外部鏈接',
    description: '',
    address: '',
    url: '',
    metaPairs: [],
    tags: [],
    imageUrl: '',
  };
};
